interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({
  currentPage,
  totalPages,
  onChange,
}: PaginationProps) {
  if (totalPages <= 1) {
    return null;
  }

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  const baseBtn =
    "flex h-9 min-w-9 items-center justify-center rounded-md border px-3 text-sm transition-colors";

  return (
    <nav
      className="flex flex-wrap items-center justify-center gap-2"
      aria-label="分页导航"
    >
      <button
        type="button"
        onClick={() => onChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`${baseBtn} border-background-300 text-foreground-700 hover:border-primary-500 hover:text-foreground-950 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300`}
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          aria-current={page === currentPage ? "page" : undefined}
          className={`${baseBtn} ${
            page === currentPage
              ? "border-primary-500 bg-primary-500 font-semibold text-foreground-950"
              : "border-background-300 text-foreground-700 hover:border-primary-500 hover:text-foreground-950"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`${baseBtn} border-background-300 text-foreground-700 hover:border-primary-500 hover:text-foreground-950 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300`}
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}